import {createFileRoute} from '@tanstack/react-router';
import {AuthDonePage} from '../pages/login/AuthDonePage';

export const Route = createFileRoute('/auth-done')({
  component: AuthDonePage,
});
